import React, { useState } from 'react';
import { PageWrapper } from 'components/PageWrapper';
import { colors } from 'assets/styled/tokens';
import { MobileNavbar } from 'components';
import { NewMenu } from 'components/Menu/NewMenu';
import { HeaderFiltersPage } from 'containers/HeaderFiltersPage';
import { AgendaContainer, KnowMoreLink, PageContent, PageContentHeader } from './styled';
import { Breadcrumbs } from 'newComponents/Navigation/Breadcrumbs';
import { Calendar } from './components/Calendar';
import { ReactComponent as OpenIcon } from 'assets/icons/open-icon-gray.svg';
import { FilterExecutorModal } from './components/FilterExecutorModal';
import { EnvironmentsEquipmentModal } from './components/EnvironmentsEquipmentModal';
import { PlanosModal } from './components/PlanosModal';
import { useCalendarFilters } from './hooks/useCalendarFilters';
import { useCalendarNavigation } from './hooks/useCalendarNavigation';

interface AgendaProps {
  pathname: string;
}

export const Agenda: React.FC<AgendaProps> = ({ pathname }) => {
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const { currentDate, view, viewsOptions, handleViewChange, goToToday, navigate, weekDays } = useCalendarNavigation();
  const {
    executoresOptions,
    tempExecutoresValues,
    handleTempExecutoresChange,
    setoresOptions,
    tempSetoresValues,
    handleTempSetoresChange,
    tempMaintenanceUnitsForExecutoresSetoresValues,
    handleTempMaintenanceUnitsForExecutoresSetoresChange,
    applyExecutoresSetoresFilters,
    clearExecutoresSetoresFilters,
    executoresSetoresModalOpen,
    setExecutoresSetoresModalOpen,
    ambientesEquipamentosModalOpen,
    setAmbientesEquipamentosModalOpen,
    maintenanceUnitsOptions,
    tempMaintenanceUnitsValues,
    handleTempMaintenanceUnitsChange,
    areaGroupsOptions,
    tempAreaGroupsValues,
    handleTempAreaGroupsChange,
    areaSubgroupsOptions,
    tempAreaSubgroupsValues,
    handleTempAreaSubgroupsChange,
    areasOptions,
    tempAreasValues,
    handleTempAreasChange,
    equipmentTypesOptions,
    tempEquipmentTypesValues,
    handleTempEquipmentTypesChange,
    equipmentOptions,
    tempEquipmentValues,
    handleTempEquipmentChange,
    applyAmbientesEquipamentosFilters,
    clearAmbientesEquipamentosFilters,
    loadMoreAreas,
    searchArea,
    loadMoreEquipamentos,
    searchEquipamento,
    planosModalOpen,
    setPlanosModalOpen,
    tempPlanosValues,
    handleTempPlanosChange,
    tempMaintenanceUnitsForPlanosValues,
    handleTempMaintenanceUnitsForPlanosChange,
    applyPlanosFilters,
    clearPlanosFilters,
    planosOptions,
    type,
    setType,
    planosSelectionLabel,
    openFilters,
    setOpenFilters,
    hasActiveFilters,
    clearAllFilters,
    events,
    isLoadingEvents,
    fetchAgendaTasks,
  } = useCalendarFilters({ currentDate, view });
  return (
    <>
      <PageWrapper background={colors.pampas}>
        <MobileNavbar />

        <NewMenu setIsSubMenuOpen={setIsSubMenuOpen} />

        <HeaderFiltersPage isSubMenuOpen={isSubMenuOpen} location={pathname}>
          <PageContent>
            <PageContentHeader>
              <Breadcrumbs />
              <KnowMoreLink
                href="https://leankeep.movidesk.com/kb/pt-br/article/575405/nova-agenda-web?ticketId=&q="
                target="_blank"
              >
                Saiba como usar a agenda
                <OpenIcon />
              </KnowMoreLink>
            </PageContentHeader>
            <AgendaContainer>
              <Calendar
                setExecutoresSetoresModalOpen={setExecutoresSetoresModalOpen}
                setAmbientesEquipamentosModalOpen={setAmbientesEquipamentosModalOpen}
                setPlanosModalOpen={setPlanosModalOpen}
                currentDate={currentDate}
                view={view}
                viewsOptions={viewsOptions}
                handleViewChange={handleViewChange}
                goToToday={goToToday}
                navigate={navigate}
                weekDays={weekDays}
                type={type}
                setType={setType}
                planosSelectionLabel={planosSelectionLabel}
                openFilters={openFilters}
                setOpenFilters={setOpenFilters}
                hasActiveFilters={hasActiveFilters}
                clearAllFilters={clearAllFilters}
                events={events}
                isLoadingEvents={isLoadingEvents}
                fetchAgendaTasks={fetchAgendaTasks}
              />
            </AgendaContainer>
          </PageContent>
        </HeaderFiltersPage>
      </PageWrapper>
      {executoresSetoresModalOpen && (
        <FilterExecutorModal
          title={'Executores e Setores'}
          maintenanceUnitsOptions={maintenanceUnitsOptions}
          maintenanceUnitsValues={tempMaintenanceUnitsForExecutoresSetoresValues}
          onMaintenanceUnitsChange={handleTempMaintenanceUnitsForExecutoresSetoresChange}
          disableSetoresAndExecutores={tempMaintenanceUnitsForExecutoresSetoresValues.length === 0}
          executoresFields={executoresOptions}
          setoresFields={setoresOptions}
          executoresValues={tempExecutoresValues}
          setoresValues={tempSetoresValues}
          onExecutoresChange={handleTempExecutoresChange}
          onSetoresChange={handleTempSetoresChange}
          onFilter={applyExecutoresSetoresFilters}
          onClearFilters={clearExecutoresSetoresFilters}
          setClose={(open: boolean) => {
            if (!open) {
              clearExecutoresSetoresFilters();
            }
          }}
        />
      )}
      {ambientesEquipamentosModalOpen && (
        <EnvironmentsEquipmentModal
          title={'Ambientes e Equipamentos'}
          maintenanceUnitsOptions={maintenanceUnitsOptions}
          areaGroupsOptions={areaGroupsOptions}
          areaSubgroupsOptions={areaSubgroupsOptions}
          areasOptions={areasOptions}
          equipmentTypesOptions={equipmentTypesOptions}
          equipmentOptions={equipmentOptions}
          maintenanceUnitsValues={tempMaintenanceUnitsValues}
          areaGroupsValues={tempAreaGroupsValues}
          areaSubgroupsValues={tempAreaSubgroupsValues}
          areasValues={tempAreasValues}
          equipmentTypesValues={tempEquipmentTypesValues}
          equipmentValues={tempEquipmentValues}
          onMaintenanceUnitsChange={handleTempMaintenanceUnitsChange}
          onAreaGroupsChange={handleTempAreaGroupsChange}
          onAreaSubgroupsChange={handleTempAreaSubgroupsChange}
          onAreasChange={handleTempAreasChange}
          onEquipmentTypesChange={handleTempEquipmentTypesChange}
          onEquipmentChange={handleTempEquipmentChange}
          onFilter={applyAmbientesEquipamentosFilters}
          onClearFilters={clearAmbientesEquipamentosFilters}
          onLoadMoreAreas={loadMoreAreas}
          onSearchArea={searchArea}
          onLoadMoreEquipamentos={loadMoreEquipamentos}
          onSearchEquipamento={searchEquipamento}
          setClose={(open: boolean) => {
            if (!open) {
              setAmbientesEquipamentosModalOpen(false);
            }
          }}
        />
      )}
      {planosModalOpen && (
        <PlanosModal
          title={'Planos'}
          maintenanceUnitsOptions={maintenanceUnitsOptions}
          planosOptions={planosOptions}
          maintenanceUnitsValues={tempMaintenanceUnitsForPlanosValues}
          planosValues={tempPlanosValues}
          onMaintenanceUnitsChange={handleTempMaintenanceUnitsForPlanosChange}
          onPlanosChange={handleTempPlanosChange}
          onFilter={applyPlanosFilters}
          onClearFilters={clearPlanosFilters}
          setClose={(open: boolean) => {
            if (!open) {
              setPlanosModalOpen(false);
            }
          }}
        />
      )}
    </>
  );
};
